// src/theme-provider/foundations/font-sizes.ts
var fontSizes = {
  bodyRegular: "1rem",
  bodySmall: "0.9rem",
  captionRegular: "0.75rem",
  captionSmall: "0.625rem",
  h1: "4rem",
  h2: "3.5rem",
  h3: "3rem",
  h4: "2.5rem",
  h5: "2rem",
  h6: "1.5rem"
};
var font_sizes_default = fontSizes;

export {
  font_sizes_default
};
